import { useState, useEffect } from "react";
import modelImages from "../mockups/modelMockup";
import getVariationCombos from "../utils/getVariationCombos";
import getVariationIdFromCombo from "../utils/getVariationIdFromCombo";

const useVariations = ({ parameters, configurationId, activeVariationId, extraSuffixes }) => {
  const [variations, setVariations] = useState([]);

  const deleteImage = (newVariation) => {
    setVariations((state) => {
      const newState = state.map((currentVariation) => {
        if (newVariation?.id === currentVariation?.id) {
          return {
            ...currentVariation,
            img: null,
          };
        }
        return { ...currentVariation };
      });
      return newState;
    });
  };

  const togglePrice = (newVariation) => {
    setVariations((state) => {
      const newState = state.map((currentVariation) => {
        if (newVariation?.id === currentVariation?.id) {
          return {
            ...currentVariation,
            price: newVariation?.price,
            manualPrice: !currentVariation?.manualPrice,
          };
        }
        return { ...currentVariation };
      });
      return newState;
    });
  };

  const setManualPrice = (newVariation) => {
    setVariations((state) => {
      const newState = state.map((currentVariation) => {
        if (newVariation?.id === currentVariation?.id) {
          return {
            ...currentVariation,
            price: newVariation?.price,
          };
        }
        return { ...currentVariation };
      });
      return newState;
    });
  };

  useEffect(() => {
    const configurationParameters = parameters[configurationId];
    const combos = getVariationCombos(configurationParameters);
    const newVariations = combos.map((combo) => {
      const result = {};
      result.id = getVariationIdFromCombo(configurationId, combo, extraSuffixes);
      const parameterArray = configurationParameters?.map((p, i) => ({
        [p.id?.toLowerCase()]: combo[i],
      }));

      if (modelImages[result.id] != null) {
        result.img = modelImages[result.id];
      } else {
        // Fallback: try matching suffix against 111-111 images
        const suffix = result.id.replace(`${configurationId}-`, "");
        const fallbackKey = `111-111-${suffix}`;
        if (modelImages[fallbackKey] != null) {
          result.img = modelImages[fallbackKey];
        }
      }
      if (activeVariationId === result.id) {
        result.active = true;
      }

      return { ...result, parameters: parameterArray, manualPrice: false };
    });

    // Mock: set manual price for specific variations
    const manualPriceOverrides = {
      "222-222-180-SVI": 700,
      "222-222-180-VID": 750,
      "222-222-180-TAM": 700,
    };
    newVariations.forEach((v) => {
      if (manualPriceOverrides[v.id] != null) {
        v.manualPrice = true;
        v.price = manualPriceOverrides[v.id];
      }
    });

    setVariations(newVariations);
    // eslint-disable-next-line
  }, [parameters ? JSON.stringify(parameters) : "", JSON.stringify(extraSuffixes || "")]);

  useEffect(() => {
    setVariations((state) => {
      const newState = state?.map((currentVariation) => {
        if (currentVariation?.id === activeVariationId)
          return { ...currentVariation, active: true };
        return { ...currentVariation, active: false };
      });
      return newState;
    });
    // eslint-disable-next-line
  }, [activeVariationId]);

  return { variations, togglePrice, setManualPrice, deleteImage };
};

export default useVariations;
